import { z } from "zod";

// Phase 6 typed configSchema for the `static-note` template (D-14).
// Replaces the Phase 01.1 z.unknown() placeholder in TEMPLATE_CATALOG; Pass 2A
// in validateRecipe now enforces shape (body length, tone enum, no extra fields).
//
// Markdown rendering: Plan 09 ships the renderer with an allowlist + URL-scheme
// filter (UI-SPEC §"Markdown Allowlist"). The schema does NOT sanitize markdown
// content — that responsibility lives at the renderer. The schema only bounds
// length and constrains the tone enum.
//
// D-13: static-note is the docs walkthrough target (`docs/ADD-A-TEMPLATE.md`).
// The schema is intentionally simple — easy to teach in a single screen.
//
// isolatedDeclarations + verbatimModuleSyntax + exactOptionalPropertyTypes
// (Phase 01.1 D-10/D-15): export interface explicitly + annotate const with
// z.ZodType<StaticNoteConfig>.

export interface StaticNoteConfig {
  body: string;
  tone: "info" | "warning" | "note";
  visibilityConstraintId?: string | undefined;
}

export const StaticNoteConfigSchema: z.ZodType<StaticNoteConfig> = z.strictObject({
  body: z.string().min(1).max(2000),
  tone: z.enum(["info", "warning", "note"]).default("info"),
  visibilityConstraintId: z.string().min(1).optional(), // 11.6 D2 — optional gating: when set, the renderer (Plan 06) shows the note only if isVisibleById(...) is true; absent = render unconditionally (preserved).
});
